import { render, staticRenderFns } from "./LeadInfo.vue?vue&type=template&id=a2f2f6ce"
import script from "./LeadInfo.vue?vue&type=script&lang=js"
export * from "./LeadInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports